import { useContext } from 'react';
import { SIDEBAR_LIST } from './constants';
import Modalv2 from '../../Components/Modalv2';
import SiteSettings from './Components/SiteSettings';
import FloorPricingConfig from './Components/FloorPricingConfig';
import ServiceConfig from './Components/ServiceConfig';
import ManualFloorRulesConfig from './Components/ManualFloorRulesConfig';
import ConfigEditorMainPage from '../../Components/ConfigEditorMainPage';
import { BannerFpContext } from '../../Contexts/BannerFpContext';
import { Modalv2Context } from '../../Contexts/Modalv2Context';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import MiscellaneousServicesOutlinedIcon from '@mui/icons-material/MiscellaneousServicesOutlined';
import FiberManualRecordOutlinedIcon from '@mui/icons-material/FiberManualRecordOutlined';
import GeneralButton from '../../Components/GeneralButton';
import FinalOverview from './Components/FinalOverview';
import { Typography } from '@mui/material';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

const settingConfigs = {
	[SIDEBAR_LIST.SITE_SETTINGS.SETTING_NAME]: <SiteSettings />,
	[SIDEBAR_LIST.FLOOR_PRICING_CONFIG.SETTING_NAME]: <FloorPricingConfig />,
	[SIDEBAR_LIST.SERVICE_CONFIG.SETTING_NAME]: <ServiceConfig />,
	[SIDEBAR_LIST.MANUAL_FLOOR_RULES.SETTING_NAME]: <ManualFloorRulesConfig />
};

const BannerFpConfigGenerator = () => {
	const { bannerFpConfig } = useContext(BannerFpContext);
	const { updateModalContent } = useContext(Modalv2Context);

	const sidebarConfig = [
		{
			icon: <LanguageOutlinedIcon fontSize="medium" />,
			label: SIDEBAR_LIST.SITE_SETTINGS.LABEL,
			settingName: SIDEBAR_LIST.SITE_SETTINGS.SETTING_NAME
		},
		{
			icon: <PriceChangeOutlinedIcon fontSize="medium" />,
			label: SIDEBAR_LIST.FLOOR_PRICING_CONFIG.LABEL,
			settingName: SIDEBAR_LIST.FLOOR_PRICING_CONFIG.SETTING_NAME
		},
		{
			icon: <MiscellaneousServicesOutlinedIcon fontSize="medium" />,
			label: SIDEBAR_LIST.SERVICE_CONFIG.LABEL,
			settingName: SIDEBAR_LIST.SERVICE_CONFIG.SETTING_NAME
		},
		{
			icon: <FiberManualRecordOutlinedIcon fontSize="medium" />,
			label: SIDEBAR_LIST.MANUAL_FLOOR_RULES.LABEL,
			settingName: SIDEBAR_LIST.MANUAL_FLOOR_RULES.SETTING_NAME
		},
		{
			isButton: true,
			button: (
				<GeneralButton
					system={SYSTEMS.BANNER_FP}
					name="BANNER_FP_OPEN_FINAL_OVERVIEW_MODAL_BUTTON"
					color="primary"
					variant="contained"
					size="medium"
					onClick={() => updateModalContent(<FinalOverview />)}
				>
					<Typography fontWeight="bold">Final Overview</Typography>
				</GeneralButton>
			)
		}
	];

	return (
		<>
			<ConfigEditorMainPage
				sidebarConfig={sidebarConfig}
				settingConfigs={settingConfigs}
				system={SYSTEMS.BANNER_FP}
				isLoading={!bannerFpConfig}
			/>
			<Modalv2 />
		</>
	);
};
export default BannerFpConfigGenerator;
